<template>
  <div class="toggle-wrapper">
    {{ leftTxt }}
    <label class="switch">
      <input type="checkbox" :disabled="disable" v-model="toggleValue" @click="$emit('toggle', toggleValue)" />
      <span class="slider round" :class="{ disabled: disable }"></span>
    </label>
    {{ rightTxt }}
  </div>
</template>
<script>
export default {
  props: {
    leftTxt: {
      type: String,
      default: '',
    },
    rightTxt: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      toggleValue: false,
    };
  },
  mounted() {
    this.toggleValue = this.value;
  },
};
</script>
<style lang="scss" scopted>
$background-color_1: #24475c;
$background-color_3: #2196f3;

.toggle-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

/* Rounded sliders */
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
  margin: 0 5px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $background-color_1;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-image: linear-gradient(to bottom, #f4ea9f, #eac35a);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  &.disabled {
    opacity: 0.6;
  }
}
input {
  &:checked {
    + {
      .slider {
        background-color: $background-color_3;
        &:before {
          -webkit-transform: translateX(20px);
          -ms-transform: translateX(20px);
          transform: translateX(20px);
        }
      }
    }
  }
  &:focus {
    + {
      .slider {
        box-shadow: 0 0 1px #2196f3;
      }
    }
  }
}
.slider.round {
  border-radius: 24px;
  &:before {
    border-radius: 50%;
  }
}
</style>
